/**
 * Client for the Hats & Ladders REST API (API Gateway).
 *
 * Uses the same Cognito ID token that AppSync uses.
 */

import { isTokenExpired, refreshAccessToken } from "@/utils/tokenUtils";

const getApiBaseUrl = (): string => {
  const url = (import.meta as any).env.VITE_APP_HL_API_ENDPOINT as string;
  if (!url) throw new Error("VITE_APP_HL_API_ENDPOINT is not set");
  return url.replace(/\/+$/, "");
};

const getAuthToken = async (): Promise<string> => {
  let token = localStorage.getItem("id_token");
  if (!token || isTokenExpired(token)) {
    token = await refreshAccessToken();
  }
  return token;
};

/**
 * Make an authenticated request to the Hats API Gateway.
 */
export const hatsApiFetch = async <T = unknown>(
  path: string,
  init?: RequestInit,
): Promise<T> => {
  const baseUrl = getApiBaseUrl();
  const token = await getAuthToken();

  const response = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
      ...init?.headers,
    },
  });

  if (!response.ok) {
    const body = await response.text();
    throw new Error(`API ${response.status}: ${body}`);
  }

  return response.json() as Promise<T>;
};
